import {Component, Input, OnDestroy} from '@angular/core';
import {SubFormComponent} from '../_subform';
import {FormBuilder} from '@angular/forms';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import {BankFieldsService} from './bank-fields.service';

/**
 * Поля банковских реквизитов
 */

@Component({
    selector: 'app-bank-fields',
    templateUrl: './bank-fields.component.html'
})

export class BankFieldsComponent extends SubFormComponent implements OnDestroy {
    /**
     * В разных местах поля банка могут быть обязательными, а могут и не быть, поэтому такой параметр
     * @type {boolean}
     */
    @Input() required = false;
    @Input() width;

    private rcbicLength = 9;

    public formGroupTemplate = this._fb.group({
        _rcbic_touched: [false],  // Заполняли ли данные? Если true, то заполнять из API не надо
        RCBIC: [],
        bank_name: [],
        correspondent_account: [],
        operating_account: [],
    });

    constructor(
        private _fb: FormBuilder,
        private service: BankFieldsService,
    ) {
        super();
    }

    afterInit() {
        const bicValue = this.form.get('RCBIC').value;

        if (this.isFormTouched()) {
            return;
        }

        // Если БИК банка уже заполнен, то ничего делать не будем и на этом инициализация окончена
        if (this.isRcBicValid(bicValue)) {
            return;
        }

        this.subs.push(
            this.form.get('RCBIC').valueChanges.pipe(
                debounceTime(30),
                distinctUntilChanged(),
                filter((v: string) => this.isRcBicValid(v))
            ).subscribe((v) => this.onRcbicComplete(v))
        );
    }

    private isRcBicValid(value: string) {
        return Boolean(value) && value.length === this.rcbicLength && value.indexOf('_') < 0;
    }

    private isFormTouched() {
        return this.form.get('_rcbic_touched').value === true;
    }

    private onRcbicComplete(value: string) {
        this.form.get('_rcbic_touched').patchValue(true);
        this.unsubscribe();
        this.service.get({
            queryParams: {
                rcbic: value
            }
        }).toPromise().then((data: object) => {
            this.form.patchValue(data);
        }, (error) => {
            /**
             * Do nothing cause not necessary, but have to handle error
             */
        });
    }

    private unsubscribe() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

    ngOnDestroy() {
        this.unsubscribe();
    }
}
